import { services } from "../../constants/services";
import { getAll } from "../../utils/api";

export const GetAnalyticsFiltersService = async () => {
  const response: any = await getAll<any[]>(`${services.analytics}/filters`);
  return response?.data;
};